<template lang="pug">
	.donation
		DonationError(v-if="formState==FORM_STATES.ERROR || formState==FORM_STATES.FORM_AND_ERROR", :transaction-id="transactionId")
		DonationTechnicalError(v-if="formState==FORM_STATES.TECHNICAL_ERROR", :transaction-id="transactionId")
		DonationSuccess(v-if="formState==FORM_STATES.SUCCESS", :transaction-id="transactionId")
		.section.section--white(v-if="formState==FORM_STATES.LOADING")
			.donation-loader
				.loader
					.loader__inner
						.loader__gap
						.loader__left
							.loader__half-circle
						.loader__right
							.loader__half-circle
		DonationForm(ref="form", 
			:form-data="formData",
			:form-state="formState",
			:mid="mid",
			:project-name="projectName",
			:merchant-name="merchantName",
			:captcha-img="captcha.htmlFragment",
			:captcha-error="captchaError",
			@captcha-keyup="resetCaptchaError",
			@submit="send")
				template(v-slot:legal-block="")
					slot(name="legal-block")
		.section.section--white(v-if="formState==FORM_STATES.SUCCESS")
			slot(name="success-modul")
</template>

<script>
import DonationForm from './donation-form/donation-form.vue';
import DonationSuccess from './donation-success/donation-success.vue';
import DonationError from './donation-error/donation-error.vue';
import DonationTechnicalError from './donation-technical-error/donation-technical-error.vue';
import DonationApi from '../../api/donation-api';
import CaptchaApi from '../../api/captcha-api';
import { FORM_STATES } from '../../common/js/constants/constants';
import query from 'querystring-component';
const CAPTCHA_ID = 'DONATION_DONATE';
const SIMPLE_STATES = {
	SUCCESS: 'SUCCESS'
};
export default {
	data: () => ({
		formData: null,
		formState: FORM_STATES.FORM,
		transactionId: null,
		captcha: {
			captchaKey: null,
			htmlFragment: null
		},
		captchaError: false
	}),
	props: {
		projectName: {
			required: true,
			type: String
		},
		merchantName: {
			required: true,
			type: String
		},
		mid: {
			required: true,
			type: String
		}
	},
	components: {
		DonationForm,
		DonationError,
		DonationSuccess,
		DonationTechnicalError
	},
	computed: {
		FORM_STATES: () => FORM_STATES
	},
	methods: {
		backToForm() {
			this.formState = FORM_STATES.FORM;
			this.resetCaptcha();
		},
		resetCaptcha() {
			this.$refs.form.resetCaptcha();
			this.generateCaptcha(CAPTCHA_ID);
		},
		resetCaptchaError() {
			this.captchaError = false;
		},
		async loadFormData() {
			try {
				this.formState = FORM_STATES.LOADING;
				const response = await DonationApi.loadFormData(this.transactionId);
				this.formData = response.data;
			} finally {
				this.formState = FORM_STATES.FORM_AND_ERROR;
			}
		},
		async send(data) {
			try {
				this.formState = FORM_STATES.LOADING;
				this.captchaError = false;
				const dataToSend = Object.assign({}, data, { captchaKey: this.captcha.captchaKey, url: window.location.href });
				const response = await DonationApi.submit(dataToSend);
				window.location.href = response.data.reDirectUrl;
			} catch (err) {
				if (err.response.status == 400) {
					if (err.response.data && err.response.data.errors && err.response.data.errors == 'captchaText') {
						this.captchaError = true;
						this.resetCaptcha();
						this.formState = FORM_STATES.FORM;
					} else if (err.response.data) {
						this.$gtm.trackEvent({ event: 'donationTransferFailed' });
						this.formState = FORM_STATES.ERROR;
					}
				} else {
					this.$gtm.trackEvent({ event: 'donationTransferFailed' });
					this.formState = FORM_STATES.ERROR;
				}
			}
		},
		async generateCaptcha() {
			try {
				const response = await CaptchaApi.generateCaptcha(CAPTCHA_ID);
				this.captcha = response.data;
			} catch (err) {
				this.formState = FORM_STATES.TECHNICAL_ERROR;
			}
		},
		async parseQueryParams() {
			const queryParams = query.parse(window.location.search.substring(1));
			if (queryParams.r) {
				const simpleParams = JSON.parse(atob(queryParams.r));
				if (simpleParams.e == SIMPLE_STATES.SUCCESS) {
					this.$gtm.trackEvent({ event: 'donationTransferSuccess' });
					this.formState = FORM_STATES.SUCCESS;
				} else {
					this.$gtm.trackEvent({ event: 'donationTransferFailed' });
					this.formState = FORM_STATES.FORM_AND_ERROR;
				}
				if (simpleParams.t) {
					this.transactionId = simpleParams.t;
					if (simpleParams.e != SIMPLE_STATES.SUCCESS) {
						await this.loadFormData();
					}
				}
			}
			this.generateCaptcha();
		}
	},
	created() {
		this.parseQueryParams();
	}
};
</script>

<style lang="scss" scoped>
@import '@ui-common/sf-style-utils/lib/helpers/_colors.scss';
@import '@ui-common/sf-style-utils/lib/helpers/_queries.scss';

.donation-loader {
	min-height: 90px;
}
</style>
<style lang="scss">
@import '@ui-common/sf-style-utils/lib/helpers/_colors.scss';
@import '@ui-common/sf-style-utils/lib/helpers/_queries.scss';

.donation .sf-feedback {
	@include media('>=tablet') {
		margin: 0 auto;
		width: 544px;
	}
}
</style>
